export default class TabulatorAccessors {
    static nullValueDownloadAccessor = (value, data, type, params: {}, component): string => {
        return value ?? '-';
    }
}